import consumer from "./consumer"

consumer.subscriptions.create("NotificationChannel", {
  connected() {
    console.log("Connected to NotificationChannel");
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    // 1. Show Toastr notification (if available)
    if (typeof toastr !== 'undefined') {
      toastr.options = {
        "closeButton": true,
        "progressBar": true,
        "positionClass": "toast-top-right",
        "timeOut": "7000"
      };
      toastr.info(data.message, "Nueva Notificación");
    }

    // 2. Update Badge Counters
    if (typeof window.updateNavTotalCounters === 'function') {
      window.updateNavTotalCounters(data.unread_count);
    }

    // 3. Dynamically prepend to the dropdown list
    var $list = $('.dropdown-notifications-list .list-group-flush');
    if ($list.length) {
      // Remove "No hay notificaciones" message if it exists
      $list.find('.text-muted').closest('div.py-10').remove();

      var html = `
        <div class="list-group-item list-group-item-action dropdown-notifications-item" data-id="${data.id}">
          <div class="d-flex align-items-center">
            <div class="symbol symbol-35px me-4">
              <div class="symbol-label bg-light-warning">
                <i class="fas fa-bell text-warning"></i>
              </div>
            </div>
            <div class="d-flex flex-column flex-grow-1">
              <span class="fs-7 text-dark text-hover-primary fw-bold">Notificación</span>
              <span class="fs-8 text-muted fw-bold">${data.message}</span>
              <span class="fs-9 text-muted">${data.time || 'Ahora'}</span>
            </div>
            <div class="d-flex align-items-center ms-2">
              <a href="#" class="btn btn-sm btn-icon btn-active-light-primary dropdown-notifications-read" title="Marcar como leída">
                <span class="badge badge-sm badge-circle badge-primary"></span>
              </a>
              <a href="#" class="btn btn-sm btn-icon btn-active-light-primary dropdown-notifications-archive" title="Eliminar">
                <i class="fas fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      `;
      $list.prepend(html);
    }

    // 4. Optionally append to Dashboard if user is on it
    var $dashList = $('.timeline'); // Based on _card_my_notifications.html.erb
    if ($dashList.length) {
      // Remove empty message if exists
      $dashList.find('.badge-light-success').remove();

      var dashHtml = `
        <div class="notification_item" data-id="${data.id}">
          <div id="mta_notification_${data.id}">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="symbol symbol-circle symbol-40px me-4 d-flex align-items-center">
                  <div class="symbol-label bg-light">
                    <span class="svg-icon svg-icon-2 svg-icon-gray-500 text-success">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 9H6C5.4 9 5 8.6 5 8C5 7.4 5.4 7 6 7H18C18.6 7 19 7.4 19 8C19 8.6 18.6 9 18 9ZM16 12C16 11.4 15.6 11 15 11H6C5.4 11 5 11.4 5 12C5 12.6 5.4 13 6 13H15C15.6 13 16 12.6 16 12Z" fill="currentColor" />
                      </svg>
                    </span>
                  </div>
                </div>
                <div class="p-3">
                  <span class="text-muted me-2 fs-7">
                    <small>Agregado: ${data.time || 'Ahora'}</small>
                  </span>
                  <div class="fs-5 fw-semibold my-2">${data.message}</div>
                </div>
              </div>
              <div class="me-6">
                <a href="#" class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary w-25px h-25px btn-mark_notification_read" 
                  data-notification-id="${data.id}">
                  <span class="svg-icon svg-icon-muted svg-icon-2">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>
                      <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor"/>
                    </svg>
                  </span>
                </a>
              </div>
            </div>
            <div class="separator separator-dashed"></div>
          </div>
        </div>
      `;
      $dashList.prepend(dashHtml);
    }
  }
});
